import * as types from 'src/localization/types';

export const localized = (env: types.Env) => ({
  name: env.localizer('components.InstitutionDetails.name'),
  type: env.localizer('components.InstitutionDetails.type'),
  status: env.localizer('components.InstitutionDetails.status'),
  loginTypes: env.localizer('components.InstitutionDetails.loginTypes'),
  loginCertificateType: env.localizer('components.InstitutionDetails.loginCertificateType')
});
